import React from "react";
import DotLegalFullScreenSpinner from "../../common/components/dotLegalFullScreenSpinner/DotLegalFullScreenSpinner";
import DotLegalStepper from "../../common/components/dotLegalStepper/DotLegalStepper";
import { useSystemHook } from "./SystemEdit.hooks";
import { useUrlProvider } from "../../useUrlProvider";
import { DotLegalPageHeader, useHistoryWithReferer } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import MentionInputRender from "../../common/components/mentionInput/MentionInputRender.tsx";
import { isNullOrWhitespace } from "../../common/stringOperations.ts";
import SystemStep from "./steps/SystemStep.tsx";

function System() {
    const historyWithReferer = useHistoryWithReferer();
    const { translateString } = useTranslation();
    const { getSystemOverviewUrl } = useUrlProvider();

    const { steps, activeStep, changeStep, onChange, onCustomFieldChange, validationErrors, isLoading, system, systemTemplate, systemId, refetchSystem } =
        useSystemHook();

    const breadCrumbs = [
        { name: translateString("systems"), link: "/privacy/systems" },
        {
            name: system ? `${system?.name} ${system?.userFriendlyId ? `(${system.userFriendlyId})` : ""}` : undefined,
            tooltip: isNullOrWhitespace(system?.description) ? undefined : <MentionInputRender value={system.description ?? ""} linkColor={"white"} />,
        },
    ];

    return (
        <React.Fragment>
            <DotLegalPageHeader breadCrumbs={breadCrumbs} />
            {isLoading ? (
                <React.Fragment>
                    <DotLegalFullScreenSpinner />
                </React.Fragment>
            ) : (
                <DotLegalStepper
                    steps={steps}
                    activeStep={activeStep.stepType}
                    header={activeStep.name}
                    inProgess={isLoading}
                    onStepClick={(step) => changeStep(step)}
                    onSaveClick={async () => {
                        historyWithReferer.push(getSystemOverviewUrl(systemId!));
                    }}
                    overviewButtonText={translateString("complete")}
                >
                    <SystemStep
                        isLoading={isLoading}
                        systemId={systemId!}
                        system={system}
                        systemTemplateStep={systemTemplate?.steps.find((x) => x.order === activeStep.stepType)!}
                        onChange={onChange}
                        onCustomFieldChange={onCustomFieldChange}
                        onRefetchSystem={refetchSystem}
                        validationErrors={validationErrors}
                    />
                </DotLegalStepper>
            )}
        </React.Fragment>
    );
}

export default System;
